export enum Methods {
    setLocale = 'setLocale',
    sign = 'sign'
}

export class NcaLayerRequest {
    clazz: string | null
    method: Methods
    args: Array<string> | Args
    module: string | null

    constructor(clazz: string | null, method: Methods, args: Array<string> | Args, module: string | null = null) {
        this.clazz = clazz
        this.method = method
        this.args = args
        this.module = module
    }
}

export interface Args {
    allowedStorages: string[]
    format: 'xml' | 'json' | 'cms'
    data: any
    signingParams: any
    signerParams: SignerParams
    locale: string
}

export interface SignerParams {
    extKeyUsageOids: string[]
    chain: string[]
}


export class NcaLayerResponse {
    result?: any;
    secondResult?: string;
    errorCode?: string;
    body?: {result: string[]}

    public build(response: string): void {
        try {
            const obj = JSON.parse(response);
            this.result = obj.result;
            this.body = obj.body;
            this.secondResult = obj.secondResult;
            this.errorCode = obj.errorCode;
        } catch(e: unknown) {
            this.result = response;
        }
    }
}

export interface Certs {
    oids: string,
    chain: string[]
}

export function hasResult(data: NcaLayerResponse): boolean {
    return (data?.body?.result || []).length > 0;
}

export function hasNoResult(data: NcaLayerResponse): boolean {
    return !hasResult(data)
}
